/* @ngInject */
const sportIconDirective = function(blockDomain: string): Record<string, any> {
	return {
		restrict: "A",
		scope: {
			code: "=sportIconCode",
			iconSet: "=?sportIconSet",
			theme: "=?sportIconTheme",
			dynamic: "=?sportIconDynamic"
		},
		link: function (scope, element, attrs) {
			function applyIcon() {
				if (scope.code) {
					if (!scope.iconSet) {
						scope.iconSet = "default";
					}
	
					if (!scope.theme) {
						scope.theme = "dark";
					}
	
					const fileExtension = scope.iconSet === "pickswise" ? "png" : "svg";
	
					attrs.$set("src", `${blockDomain}/static/assets/sport-icons/${scope.iconSet}/${scope.theme}/${scope.code.toLowerCase()}.${fileExtension}`);
					
	
					// prevent loop of directive call after image has been loaded
					element.removeAttr("team-icon-sport");
				}
			}

			applyIcon();

			if (scope.dynamic) {
				
				scope.$watch("code", newVal => {
					if (newVal) {
						applyIcon();
					}
				});
			}
			
		}
	};
};

export default sportIconDirective;